import type { SelectContext } from './select.types'

import { createContext } from '../utils'

const [SelectProvider, useSelectContext] = createContext<SelectContext>({ isOptional: true })

export { SelectProvider, useSelectContext }
